import "reflect-metadata";
import Head from "next/head";
import GlobalProctorUIProviders from "../src/AllProviders";
import "../styles/globals.scss";

function MyApp({ Component, pageProps }) {
	return (
		<GlobalProctorUIProviders>
			<>
				<Head>
					<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
				</Head>
				<Component {...pageProps} />
			</>
		</GlobalProctorUIProviders>
	);
}

export default MyApp;
